import React from "react";

function BlankLayout({ children }: { children: React.ReactNode }) {
  return <div>{children}</div>;
}

export default BlankLayout;
